<template>
    <td-dialog :title="$t(title)" :before-close="dlalogExportPictureClose" :visible="exportPictureVailable" :close-on-click-modal="false" :close-on-press-escape="false" width="400px">
        <el-form>
            <el-form-item :label="$t('pgCommon.EXPORT_ALARM_PICTURE')" class="paddingLeft20">
                <td-radio v-model="exportAlarmPic" :options="confirmOptions" keys="id" text="name"></td-radio>
            </el-form-item>
            <span style="font-size:12px;color:red;padding-left:20px">
                {{ $t('pgMessage.ALARM_EXPORT_EXPLAIN') }}
            </span>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="loading" @click="submitForm()">{{ $t('common.SURE') }}</td-button>
            <td-button @click="dlalogExportPictureClose">{{ $t('common.CLOSE') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import exportApi from '../assets/api.js';
export default {
    components: {},
    props: {
        title: {
            type: [String, Number]
        },
        // 页面是否显示
        exportPictureVailable: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 导出参数
        exportParam: {
            type: Object,
            default: function() {
                return null;
            }
        }
    },
    mounted() {},
    created() {},
    data() {
        return {
            exportAlarmPic: '1',
            loading: false,
            confirmOptions: [
                {
                    id: '1',
                    name: this.$t('pgCommon.YES')
                },
                {
                    id: '2',
                    name: this.$t('pgCommon.NOT')
                }
            ]
        };
    },

    methods: {
        // 提交
        submitForm() {
            let param = this.exportParam;
            param.exportAlarmPic = this.exportAlarmPic === '1';
            let responseType = 'arraybuffer';
            this.loading = true;
            exportApi.exportAlarmInfo(param, responseType, response => {
                this.loading = false;
                try {
                    //首先判断无文件导出，再判断状态
                    if (response.headers && response.headers.filename === undefined) {
                        let _response = JSON.parse(this.decodeUTF8(new Uint8Array(response.data)));
                        if (_response.statusCode) {
                            if (_response.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: _response.statusMessage, type: 'error' });
                                return;
                            }
                        }
                    }
                } catch (e) {
                    // this.$log.error('/device/exportAlarmInfo', e);
                }
                let blob = new Blob([response.data], { type: 'application/x-xls' });
                this.content = response.data;
                // 汉字解码
                let filename = decodeURIComponent(response.headers['filename']);
                if (window.navigator.msSaveOrOpenBlob) {
                    // 兼容IE10
                    navigator.msSaveBlob(blob, filename);
                } else {
                    //  chrome/firefox
                    let aTag = document.createElement('a');
                    aTag.download = filename;
                    aTag.href = window.URL.createObjectURL(blob);
                    aTag.click();
                    URL.revokeObjectURL(aTag.href);
                }
                this.$emit('dlalogExportPictureClose');
            });
        },
        decodeUTF8(arr) {
            var str = '';
            for (var i = 0; i < arr.length; i++) {
                str += String.fromCharCode(arr[i]);
            }
            return decodeURIComponent(escape(str));
        },
        // 关闭窗口之前需要调用的方法
        dlalogExportPictureClose() {
            this.$emit('dlalogExportPictureClose');
        }
    }
};
</script>
<style scoped>
.btnStyle {
    text-align: center;
}
</style>
